<div class="noAccess">
  <p>{{ 'installation_noAccess' | translate }}</p>
  <ion-button (click)="toLicense()">
    <small>{{ 'installation_btnToLicense' | translate }}</small>
  </ion-button>
</div>
